import React from "react";
import { Tag } from "antd";
import { RuleStatusMap } from "../utils";

import "./RuleStatusTag.css";

export default function RuleStatusTag({
  result,
  children,
}) {
  const flags = result ? RuleStatusMap.Active : RuleStatusMap.Inactive;
  const style = {
    color: flags?.color,
    backgroundColor: flags?.backgroundColor,
    borderColor: flags?.borderColor,
  };
  const label = flags?.label;

  return (
    <Tag className="RuleStatusTag" style={style}>
      <span className="content">
        <span className="text">{label}</span>
      </span>
      {children}
    </Tag>
  );
}
